import { useContext } from "react";
import styles from "./Header.module.scss";
import { useLocation } from "react-router-dom";
import { Avatar, Button } from "@mui/material";
import { AuthContext } from "../../context/AuthContext";

export const Header = () => {
  const { pathname } = useLocation();
  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error("AuthContext must be used within an AuthProvider");
  }

  const { currentUser, isAuthenticated, loading } = authContext;
  const userData = currentUser?.userData as any;
  const { first_name, last_name, name, email, profile_image, logo } =
    userData || {};

  // If not authenticated, don't show header at all
  if (!isAuthenticated) {
    return null;
  }

  // Wait for user data to load before showing header
  if (loading || !currentUser || !userData) {
    return null;
  }

  const redirectPath =
    currentUser?.userType === "organisation"
      ? `/organisation/${currentUser?.userId}`
      : `/volunteer/${currentUser?.userId}`;

  const normalizedPath = pathname.replace(/\/$/, "");
  const isOwnProfilePage = normalizedPath === redirectPath;

  const title =
    isOwnProfilePage || pathname.includes("profile")
      ? "Profil"
      : pathname.includes("documents")
        ? "Dokumenty"
        : pathname.includes("new-event")
          ? "Nová akce"
          : pathname.includes("/event/")
            ? "Detail akce"
            : pathname.includes("/volunteer/favorite")
              ? "Moje akce"
              : pathname.includes("evidence")
                ? "Evidence dobrovolníků"
                : "Přehled akcí";

  const isOrganisation = currentUser?.userType === "organisation";
  const showAvatarImage = !profile_image && !logo;

  return (
    <header className={styles.header}>
      <h3 className={styles.title}>{title}</h3>
      <Button href={redirectPath} className={styles.user}>
        {isOrganisation && logo ? (
          <img src={logo} alt="organisation-logo" className={styles.orgLogo} />
        ) : (
          <Avatar
            alt="avatar"
            src={
              showAvatarImage
                ? "https://media.istockphoto.com/id/476085198/cs/fotografie/silueta-podnikatele-jako-avatar-nebo-v%C3%BDchoz%C3%AD-profilov%C3%BD-obr%C3%A1zek.jpg?s=1024x1024&w=is&k=20&c=gX3HdpyRaMVd-6Xgp_uCF13RBnH1SfnX6ebHyMSj-U0="
                : profile_image
            }
            sx={{ width: 32, height: 32 }}
          />
        )}
        <div className={styles.info}>
          <p className={styles.name}>
            {isOrganisation ? name : `${first_name} ${last_name}`}
          </p>
          <p>{email}</p>
        </div>
      </Button>
    </header>
  );
};
